import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import GamesDescriptionBg from '../../../assets/image/gamesDescriptionBg.png'
import MainContent from '../../../components/gamesDescription/MainContent'
import Hero from '../../../components/Hero'
import Loading from '../../../components/Common/Loading'
import { ApiHandler } from '../../../helper/ApiHandler'
import { useDispatch, useSelector } from 'react-redux'

const DiamondShotGame = () => {
    const { gameID } = useParams();

    const [gameDetails, setGameDetails] = useState(null);
    const token = useSelector((state) => state.auth.token);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchGameDetails = async () => {
            try {
                const response = await ApiHandler('/get_game_list.php', 'POST', { gameID: gameID }, undefined, dispatch, navigate);
                const gameData = response.data.data[0];
                setGameDetails(gameData);
            } catch (error) {
                console.error('Failed to fetch game details:', error);
            }
        };

        fetchGameDetails();
    }, [gameID]);

    if (!gameDetails) {
        return <div>
            <Loading />
        </div>;
    }

    return (
        <>
            <Hero title={gameDetails?.game_name} bgImg={GamesDescriptionBg} backgroundColor='#290A47' />
            <MainContent gameDetails={gameDetails} />
        </>
    )
}

export default DiamondShotGame